document.addEventListener('DOMContentLoaded', function () {
  // Select the container where dropdowns are rendered
  const parentContainer = document.querySelector('.product-info-description-content');
  
  if (!parentContainer) return; // Exit if the container doesn't exist

  // Select specific dropdowns by content or other distinguishing attributes
  const promoDropdown = Array.from(parentContainer.children).find(child =>
    child.innerHTML.includes('Promotional Information')
  );

  const descriptionDropdown = Array.from(parentContainer.children).find(child =>
    child.innerHTML.includes('Description')
  );

  // Move the promo dropdown above the description dropdown
  if (promoDropdown && descriptionDropdown) {
    parentContainer.insertBefore(promoDropdown, descriptionDropdown);
  }
});